module.exports = __webpack_public_path__ + "static/media/task.211d1147.svg";